import { ApiRequestsService } from '@base/api/api.gateway';
import { ActivatedRoute } from '@angular/router';
import { HelpersService } from '@base/shared/services';
import * as i0 from "@angular/core";
import * as i1 from "../../../base-app/api/api.gateway";
import * as i2 from "@angular/router";
import * as i3 from "../../../base-app/shared/services/helpers.service";
var ProjectsService = /** @class */ (function () {
    function ProjectsService(api, route, helpers) {
        this.api = api;
        this.route = route;
        this.helpers = helpers;
        this._currentId = localStorage.getItem('eryus-currentProject') || '';
        this._currentDailyLog = localStorage.getItem('eyrus-dailylog') || null;
        this._contractDefinitionId = localStorage.getItem('eyrus-contractDefinitionId') || null;
        this._currentTask = JSON.parse(localStorage.getItem('eyrus-task') || '{}') || {};
        this._currenNote = JSON.parse(localStorage.getItem('eyrus-note') || '{}') || {};
        this._currentProject = JSON.parse(localStorage.getItem('eyrus-current-project') || '{}') || {};
        this._currentContract = JSON.parse(localStorage.getItem('eyrus-current-contract') || '{}') || {};
        this._dailyLogDate = localStorage.getItem('eyrus-dailylog-date') || null;
        this._projectName = localStorage.getItem('eyrus-project-name') || '';
    }
    Object.defineProperty(ProjectsService.prototype, "projectId", {
        get: function () {
            return this._currentId;
        },
        set: function (id) {
            localStorage.setItem('eryus-currentProject', id);
            this._currentId = id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProjectsService.prototype, "dailyLog", {
        get: function () {
            var id = localStorage.getItem('eyrus-dailylog');
            return (id === 'null' ? null : id) || null;
        },
        set: function (id) {
            localStorage.setItem('eyrus-dailylog', id);
            this._currentDailyLog = (id === 'null' ? null : id) || null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProjectsService.prototype, "contractDefinitionId", {
        get: function () {
            var id = localStorage.getItem('eyrus-contractDefinitionId');
            return (id === 'null' ? null : id) || null;
        },
        set: function (id) {
            localStorage.setItem('eyrus-contractDefinitionId', id);
            this._contractDefinitionId = (id === 'null' ? null : id) || null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProjectsService.prototype, "dailyLogDate", {
        get: function () {
            return (this._dailyLogDate === 'null' ? null : this._dailyLogDate) || null;
        },
        set: function (_date) {
            localStorage.setItem('eyrus-dailylog-date', _date);
            this._dailyLogDate = (_date === 'null' ? null : _date) || null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProjectsService.prototype, "currentProject", {
        get: function () {
            return this._currentProject;
        },
        set: function (project) {
            localStorage.setItem('eyrus-current-project', JSON.stringify(project));
            this._currentProject = project;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProjectsService.prototype, "currentContract", {
        get: function () {
            return this._currentContract;
        },
        set: function (project) {
            localStorage.setItem('eyrus-current-contract', JSON.stringify(project));
            this._currentContract = project;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProjectsService.prototype, "currentTask", {
        get: function () {
            return this._currentTask;
        },
        set: function (task) {
            localStorage.setItem('eyrus-task', JSON.stringify(task));
            this._currentTask = task;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProjectsService.prototype, "currenNote", {
        set: function (task) {
            localStorage.setItem('eyrus-note', JSON.stringify(task));
            this._currenNote = task;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProjectsService.prototype, "currentNote", {
        get: function () {
            return this._currenNote;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProjectsService.prototype, "projectName", {
        get: function () {
            return this._projectName;
        },
        set: function (name) {
            localStorage.setItem('eyrus-project-name', name);
            this._projectName = name;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Check if daily log exists and create a new one if not
     * @param calendarDate Daily log calendar date
     */
    ProjectsService.prototype.createDailyLog = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.dailyLog) {
                return resolve({
                    result: true,
                    dailyLog: {
                        dailyLogId: _this._currentDailyLog,
                        statusTypeId: _this.currentProject.statusTypeId || 1
                    }
                });
            }
            var payload = {
                contractDefinitionId: _this.route.snapshot.queryParams.contractDefinitionId || _this.contractDefinitionId,
                calendarDate: _this.route.snapshot.queryParams.calendarDate || _this.dailyLogDate
            };
            _this.api.dailyLogs.createDailyLog(payload).toPromise()
                .then(function (res) {
                _this.dailyLog = res.dailylogId;
                resolve(res);
            })
                .catch(function (err) {
                _this.helpers.errorMessage(err);
                reject(err);
            });
        });
    };
    ProjectsService.ngInjectableDef = i0.defineInjectable({ factory: function ProjectsService_Factory() { return new ProjectsService(i0.inject(i1.ApiRequestsService), i0.inject(i2.ActivatedRoute), i0.inject(i3.HelpersService)); }, token: ProjectsService, providedIn: "root" });
    return ProjectsService;
}());
export { ProjectsService };
